// Getting-started milestones.
//
// MMS has no blocking wizard and no /welcome route
// (research/mms-capture/01-empty/01-home-onboarding.jpg): a new account lands
// on a working Home screen carrying a dismissible progress stepper, and every
// section teaches itself through its own empty state.
//
// Milestones are derived from the data rather than stored as flags, on the
// ledger's principle: a stored flag is a cell two offline devices can disagree
// about, needs a write on every change, and goes stale the moment the data
// changes (delete your only student and `studentsAdded: true` is false).
//
// Only dismissal is stored, because it has no data to derive it from.

// ── The rules are `core/src/home.rs`'s ─────────────────────────────────────
//
// Which milestone is done — the account always, a student, an event and an
// invoice once the studio holds one, the last once every one between is — and
// which is current and which upcoming are `milestone_states` in the core, so
// a phone's checklist ticks the same boxes. `MILESTONES` stays as the literal
// the stepper reads, pinned to the core's by test/core/home.wasm.test.js.
import { coreSync } from './core.js';

export const MILESTONES = Object.freeze([
  { id: 'account', label: 'Create Your Account' },
  { id: 'student', label: 'Add a Student', href: '/students', cta: 'Add a Student' },
  { id: 'event', label: 'Schedule an Event', href: '/calendar', cta: 'Schedule an Event' },
  { id: 'invoice', label: 'Create an Invoice', href: '/invoices', cta: 'Create an Invoice' },
  { id: 'done', label: "You've got it!" },
]);

// counts: { studentCount, eventCount, invoiceCount }, each `Number(v) || 0`.
const counted = (counts) => [
  Number(counts?.studentCount) || 0,
  Number(counts?.eventCount) || 0,
  Number(counts?.invoiceCount) || 0,
];

export function milestoneStates(counts) {
  return coreSync().milestoneStates(...counted(counts)).map((m) => ({
    id: m.id,
    label: m.label,
    ...(m.href ? { href: m.href } : {}),
    ...(m.cta ? { cta: m.cta } : {}),
    complete: m.complete,
    current: m.current,
    upcoming: m.upcoming,
  }));
}

export function allComplete(counts) {
  return coreSync().milestonesAllComplete(...counted(counts));
}

export function completedCount(counts) {
  return coreSync().milestonesCompletedCount(...counted(counts));
}
